'use client'

import cn from 'clsx'

import { type TeamGrid as TeamGridType } from '../../../../../apps/benmax/src/types/sanity.types'

import s from './TeamGrid.module.sass'

import { Copy } from 'shared-components'

import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y } from 'swiper/modules'
import 'swiper/css'

import Select from 'react-select'

import Member from './Member/Member'
import TitleDivider from './TitleDivider/TitleDivider'

import { useState } from 'react'

type ExtendedTeamGridType = TeamGridType & {
    site: string
}

function TeamGrid({ rows, title, copy, style }: ExtendedTeamGridType) {
    const [activeCategory, setActiveCategory] = useState<number>(0)
    const style2 = style === 'style2'

    return (
        <section className={cn(s.TeamGrid, style2 && s.Style2)}>
            <div className={cn(s.Cont, 'container')}>
                {style2 ? (
                    <div className={s.TitleDivider}>
                        <TitleDivider title={title} copy={copy} />
                    </div>
                ) : (
                    <div className={s.Copy}>
                        {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
                        {copy && <Copy copy={copy} />}
                    </div>
                )}
                {rows && rows?.length > 1 && (
                    <div className={s.Select}>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={rows.map((row, index) => ({
                                value: index,
                                label: row.category,
                            }))}
                            value={{
                                value: activeCategory,
                                label: rows[activeCategory]?.category,
                            }}
                            onChange={(option) => {
                                setActiveCategory(option?.value ?? 0)
                            }}
                            isSearchable={false}
                        />
                    </div>
                )}
                {rows?.map((row, index) => {
                    const { category, members } = row

                    return (
                        <div className={s.Row} key={index}>
                            {category && (
                                <span
                                    className={'smallCaps'}
                                    dangerouslySetInnerHTML={{
                                        __html: category,
                                    }}
                                />
                            )}
                            {members && (
                                <ul>
                                    {members.map((member, index) => (
                                        <li key={index} className={s.Member}>
                                            <Member member={member} />
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )
                })}
                {rows && (
                    <div className={s.MobileSliders} key={activeCategory}>
                        {rows.map((row, index) => {
                            if (index !== activeCategory) {
                                return null
                            }
                            const { category, members } = row
                            return (
                                <div className={s.MobileRow} key={index}>
                                    {category && (
                                        <span
                                            className={'smallCaps'}
                                            dangerouslySetInnerHTML={{
                                                __html: category,
                                            }}
                                        />
                                    )}
                                    <Swiper modules={[A11y]} spaceBetween={20} slidesPerView={1.5} className={s.Slider}>
                                        {members?.map((member, index) => {
                                            return (
                                                <SwiperSlide key={index} className={s.Slide}>
                                                    <Member member={member} />
                                                </SwiperSlide>
                                            )
                                        })}
                                    </Swiper>
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        </section>
    )
}

export default TeamGrid
